package sarka.design.skoria.model

import kotlin.time.ExperimentalTime
import kotlin.time.Clock

data class ChatMessage(
    val fromMe: Boolean,
    val text: String,
    val timestampMillis: Long = nowMillis()
)

enum class ChatStatus {
    CONNECTING,
    WAITING_FOR_PARTNER,
    CONNECTED,
    DISCONNECTED,
    ERROR
}

data class ChatUiState(
    val status: ChatStatus = ChatStatus.CONNECTING,
    val messages: List<ChatMessage> = emptyList(),
    val input: String = "",
    val error: String? = null,
    val localVideoTrack: Any? = null,
    val remoteVideoTrack: Any? = null,
)

// Simple common time helper (good enough for now)
@OptIn(ExperimentalTime::class)
fun nowMillis(): Long = Clock.System.now().toEpochMilliseconds()
